const updateMemberMembershipsLoading = (state, { payload: { loading } }) => {
	state.memberMembershipsLoading = loading;
};

export default updateMemberMembershipsLoading;
